import { Pipe, PipeTransform } from '@angular/core';
import { Interval } from '@core/models/interval.model';
import { TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'durationToString'
})
export class DurationToStringPipe implements PipeTransform {

  constructor(
    private translocoSvc: TranslocoService
  ) { }

  transform(value?: Interval): any {
    if (value) {
      const { years, months, days, hours, minutes, seconds } = value;
      const arr = [
        years ? `${years} ${this.translocoSvc.translate('common.years')}` : '',
        months ? `${months} ${this.translocoSvc.translate('common.months')}` : '',
        days ? `${days} ${this.translocoSvc.translate('common.days')}` : '',
        hours ? `${hours} ${this.translocoSvc.translate('common.hours')}` : '',
        minutes ? `${minutes} ${this.translocoSvc.translate('common.minutes')}` : '',
        seconds ? `${seconds} ${this.translocoSvc.translate('common.seconds')}` : '',
      ];
      return arr.join(' ');
    } else {
      return '';
    }
  }

}
